export * from './alert-message.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/alert-message/index.ts